// Contacto.js
import React from 'react';
import { FiMail, FiPhone, FiMapPin, FiSend, FiUser } from 'react-icons/fi';

const Contacto = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container-page">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">Estamos a tu disposición</p>
          <h1 className="section-title">Contáctanos</h1>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          <form className="rounded-3xl bg-white shadow-card p-8 space-y-5">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Nombre</label>
              <div className="relative">
                <FiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  className="w-full rounded-xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary transition"
                  placeholder="Tu nombre"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Correo electrónico</label>
              <div className="relative">
                <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="email"
                  className="w-full rounded-xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary transition"
                  placeholder="tu@email.com"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Mensaje</label>
              <textarea
                className="w-full rounded-xl border border-slate-200 bg-slate-50 p-4 h-36 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary transition"
                placeholder="¿En qué podemos ayudarte?"
              ></textarea>
            </div>
            <button type="submit" className="btn-primary w-full justify-center">
              <FiSend className="w-4 h-4" />
              Enviar mensaje
            </button>
          </form>

          <div className="space-y-5">
            <div className="rounded-3xl bg-white shadow-card p-6">
              <p className="text-sm text-slate-500 mb-4">Información de contacto</p>
              <ul className="space-y-4">
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <FiUser className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Razón Social</p>
                    <p className="font-semibold text-slate-700">CORPORACIÓN INDUSTRIAL DE OCCIDENTE, C.A.</p>
                    <p className="text-sm text-slate-500">RIF: J-298981334</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <FiMail className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Correo Electrónico</p>
                    <p className="font-semibold text-slate-700">transarca.operaciones@gmail.com</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <FiPhone className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Teléfono</p>
                    <p className="font-semibold text-slate-700">+58 424-6859736</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <FiMapPin className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Dirección</p>
                    <p className="font-semibold text-slate-700">
                      Av. 2 El Milagro, Centro Comercial Lago Mall,
                      Nivel 3 Local MZO-3, Maracaibo, Estado Zulia
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="rounded-3xl bg-gradient-to-br from-primary to-primary-700 p-6 text-white">
              <p className="font-semibold mb-1">Persona de contacto</p>
              <p className="text-white/90">Jean Paul Quiñones — Presidente</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
